module.exports = __webpack_public_path__ + "static/img/bg_c.dc049bcd.png";